var route = "";

/**
 *
 * @param {*} inboundMessage
 * @param {*} session
 * @param {*} requestAttributes
 * @returns {Promise<
 * {
 *   outbound_messages: string[],
 *   session: {
 *     conversation_info: {
 *       conversation_id: string
 *     },
 *     human_mode: boolean,
 *     async_token: string
 *   },
 *   response_attributes: {
 *     conversation_status: string
 *   }
 * }>
 * }
 */
export async function callEngine(inboundMessage, session, requestAttributes) {
  //for v2 fix our session.conversation_info if it's a string
  if (route == "v2" && typeof session.conversation_info === "string") {
    session.conversation_info = JSON.parse(session.conversation_info);
  }

  const url = process.env.BASEURL + "/engine";

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-MagicForm-Version": GITHASH,
      "X-MagicForm-Route": route,
    },
    body: JSON.stringify({
      payload: {
        message: inboundMessage,
        session: session,
        //request_attributes: requestAttributes,
        user_id: requestAttributes.user_id,
        stack_id: requestAttributes.stack_id,
        channel: {
          env: "PROD",
          hostname: requestAttributes.hostname,
        },
        lang_override: requestAttributes.lang_override,
        chat_context: requestAttributes.chat_context,
        lead_context: requestAttributes.lead_context,
      },
    }),
  })
    .then((res) => {
      route = res.headers.get("X-MagicForm-Route");
      return res.json();
    })
    .then((data) => data.response);
}

export function setRoute(r) {
  route = r;
}

export function getRoute() {
  return route;
}
